export default __webpack_public_path__ + "static/security-0c6c69d78ba637362af4d0bc95dc43ff.jpg";